import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { PlayerLogo3DJerseyBack } from '../../../../../widgets/components/sm/views/playerLogo/SMPlayerLogo';

const Content = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 45px;
    margin-right: -5px;
    margin-left: -5px;

    > * {
        flex-basis: 180px;
        margin-right: 5px;
        margin-bottom: 30px;
        margin-left: 5px;
    }
`;

const Player = styled.div`
    text-align: center;

    h3 {
        margin: 0;
    }
`;

const imageWrapStyle = { position: 'relative', display: 'inline-block' };

class PlayersList extends Component {
    state = {
        teamId: (this.props.params && this.props.params.teamId) || '',
        members: {}
    };

    componentDidMount() {
        this.loadData(this.props.params);
    }

    componentWillReceiveProps({ params }) {
        if (params.teamId !== this.state.teamId) {
            this.loadData(params);
        }
    }

    loadData({ teamId = '' }) {
        Promise.all([fetch(`http://ss2.si-ab.com/teams/${teamId}/members`).then(res => res.json())]).then(res => {
            if (res) {
                const [members = {}] = res;

                this.setState({
                    teamId,
                    members
                });
            }
        });
    }

    render() {
        const { teamId = '', members: { players = [] } = {} } = this.state;
        const { tournamentId = '', seasonId = '' } = this.props.params;

        return (
            <Content>
                {players.map(player => (
                    <Link
                        key={player.id}
                        to={`/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/squad/players/${
                            player.id
                        }`}
                    >
                        <Player>
                            <PlayerLogo3DJerseyBack
                                playerId={player.id}
                                teamId={teamId}
                                seasonId={seasonId}
                                width={70}
                                number={~~player.number}
                                display="3d_jersey"
                                size="large"
                                imageWrapStyle={imageWrapStyle}
                            />
                            <h3>{player.name}</h3>
                        </Player>
                    </Link>
                ))}
                {this.props.children}
            </Content>
        );
    }
}

PlayersList.propTypes = {
    params: PropTypes.shape({
        tournamentId: PropTypes.string.isRequired,
        teamId: PropTypes.string.isRequired,
        seasonId: PropTypes.string.isRequired
    }).isRequired,
    children: PropTypes.any
};
export default PlayersList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/PlayersList.js
 **/